import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonFinish: React.FC<MprcButtonProps> = ({ text, title, color = "muted", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonFinish.text;
    const lTitle = title || theme.buttons.ButtonFinish.title;

    return (
        <MprcButton {...rest} title={lTitle} text={lText} color={color} />
    );
};
